import React, { useMemo } from 'react';
import { useAccountTimeRange } from '@ubeya/shared-web/hooks/useAccountTimeRange';
import { Invoices } from 'shared/components';
import SupplierInvoiceModal from './SupplierInvoiceModal';
import useSupplierInvoice from 'orders/hooks/useSupplierInvoice';

const SupplierInvoices = ({ supplierId, supplierBranchesIds, isShown, supplierName }) => {
  const [timeRange, setTimeRange] = useAccountTimeRange();

  const { payroll, payrollTotal, isLoading } = useSupplierInvoice({
    supplierId,
    timeRange,
    enabled: isShown
  });

  const invoicesModalParams = useMemo(
    () => ({
      payroll,
      supplierBranchesIds,
      supplierId,
      filePrefix: supplierName
    }),
    [payroll, supplierBranchesIds, supplierId, supplierName]
  );

  return (
    <Invoices
      payroll={payroll}
      payrollTotal={payrollTotal}
      isLoading={isLoading}
      setTimeRange={setTimeRange}
      timeRange={timeRange}
      InvoicesModalComponent={SupplierInvoiceModal}
      invoicesModalParams={invoicesModalParams}
      isSupplierInvoices
    />
  );
};

export default React.memo(SupplierInvoices);
